import { useEffect } from "react";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useIntl } from "react-intl";
import { useApplicationStore } from "app/entities/form-controller/abstract";
import Notification from "../../../util/Notification/Notification";
import { rootStore } from "../../../store";
import { ValidateFn } from "app/entities/form-controller/model/store";

export const useBpmFormLifecycle = (
  form: WrappedFormUtils<any>,
  fields: string[],
  initialValue: { entityName: string; id: string },
) => {
  const intl = useIntl();
  const store = useApplicationStore();

  const setUpdateAndCommit = store((s) => s.setUpdateAndCommit);
  const setEmployeePersonGroupId = store((s) => s.setEmployeePersonGroupId);
  const setValidate = store((s) => s.setValidate);
  const bpmFormData = store((s) => s.bpmStore((bpm) => bpm));

  const formValidator: ValidateFn = async () => {
    return new Promise<boolean>((resolve) => {
      try {
        form.validateFields(fields, { force: true }, (err) => {
          if (err) {
            Notification.error({
              message: intl.formatMessage({
                id: "management.editor.validationError",
              }),
            });
            resolve(false);
          } else {
            resolve(true);
          }
        });
      } catch (e) {
        console.error("validateFields error", e);
        resolve(false);
      }
    });
  };

  useEffect(() => {
    // загрузка данных процесса
    bpmFormData.getProcessInstanceData(
      bpmFormData.processInstanceBusinessKey,
      bpmFormData.processDefinitionKey,
    );

    // установка commit логики
    setUpdateAndCommit(async ({ getRawData, prepareData, commitData }) => {
      const raw = getRawData();
      const prepared = prepareData(raw);

      const res = await commitData(prepared);

      return res;
    }, form);

    setEmployeePersonGroupId(rootStore.userInfo.personGroupId);

    setValidate(formValidator, `bpmForm-${initialValue.id}`);
  }, [initialValue.id, initialValue.entityName]);
};
